// extracted by mini-css-extract-plugin
module.exports = {"actions":"payroll-form_actions__ys7jC","grid":"payroll-form_grid__duwQu"};